import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

import {
  ChangeCompanyName,
  CompanyCrmUserMappingPanel,
  DepartmentsPanel,
  useCompanyById,
  UsersOfCompanyList,
} from '@/features/company';
import { Loader } from '@/shared/ui/Loader';
import { NotFoundData } from '@/shared/ui/NotFoundData';

type TUsersOfCompanyList = { companyId?: string };

export const UsersOfCompanyListTab = ({ companyId }: TUsersOfCompanyList) => {
  const { t } = useTranslation();
  const { company, isPending } = useCompanyById(companyId);

  if (isPending) {
    return <Loader containerSize="medium" />;
  }

  if (!company) {
    return <NotFoundData title={t('company:companyNotFound')} />;
  }

  return (
    <Stack spacing={3}>
      <ChangeCompanyName companyId={company.id} defaultName={company.name} />
      <DepartmentsPanel companyId={company.id} />
      <UsersOfCompanyList companyId={company.id} />
      <CompanyCrmUserMappingPanel
        companyId={company.id}
        ownerId={company.owner_id ?? company.ownerId}
      />
    </Stack>
  );
};
